module.exports = __webpack_public_path__ + "site/img/285.c7add7a5.jpg";